import { useTranslation } from "react-i18next";
import { RowBody } from "../../../../components/RowValue/RowBody";
import ConvertToString from "../../../../components/Converter";

function PermissibleLoadCapacity({ value }) {
  const { t } = useTranslation("translation");

  return (
    <RowBody
      titleValue={<p>{t("lvText.positionMicropiles.permissibleLoadCapacity")}</p>}
      indicesValue={
        <span>
          R<sub>d</sub>
        </span>
      }
      inputValue={<span className="input">{ConvertToString(value, 0)}</span>}
      unitValue={<span>kN</span>}
    />
  );
}

export default PermissibleLoadCapacity;
